import type {SourceLogoKind} from "~/components/source-logo/sourceLogos";
import type {SupplierLogoPlace, SupplierLogoProvider} from "~/pages/supplier-360/types/Supplier360Types";
import {useSupplier360SettingsQuery} from "~/pages/supplier-360/hooks/useSupplier360Settings";

/** The Supplier 360 settings' provider key for each logo. */
export const LOGO_PROVIDER: Record<SourceLogoKind, SupplierLogoProvider> = {
    mithra: 'mithra',
    semanticVision: 'sv',
    dnb: 'dnb',
};

/**
 * Whether a provider's logo may be shown in one place, from the Supplier 360 settings' logo grid
 * (`source_logos`). Mithra staff set it per place; until they do, the server fills it from each
 * provider's `InfoSource.show_logo` with Mithra on. While the settings load only Mithra's shows,
 * so a provider logo never flashes in and out.
 */
export function useSourceLogoAllowed(place: SupplierLogoPlace): (source: SourceLogoKind) => boolean {
    const {data: settings} = useSupplier360SettingsQuery();
    return source => settings?.source_logos?.[place]?.[LOGO_PROVIDER[source]] ?? source === 'mithra';
}
